/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Button, Input, Select, Table, Typography } from 'antd';
import {
  FaCheckCircle,
  FaDownload,
  FaPen,
  FaTimesCircle,
} from 'react-icons/fa';
import usePaginationHook from '../../../../utils/usePagination';
import dayjs from 'dayjs';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import 'dayjs/locale/th';
import {
  EMemberRequestToPartnerStatus,
  EMemberStatus,
  memberRequestToPartnerFormDefaultValues,
  memberRequestToPartnerFormSchema,
} from '../components/dto/member-request-to-partner.dto';
import fitMemberToPartnerServices from '../../../../services/fit-member-to-partner.services';
import MemberRequestToPartnerModal from '../components/modal/MemberRequestToPartnerModal';

dayjs.locale('th');

const pageSize = 10;

const MemberRequestToPartnerPage = () => {
  const [memberRequestToPartnerFormOpen, setMemberRequestToPartnerFormOpen] =
    useState(false);
  const {
    data: legacySurveyLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();
  const [loading2, setLoading2] = useState(false);

  const memberRequestToPartnerForm = useForm({
    defaultValues: memberRequestToPartnerFormDefaultValues,
    resolver: memberRequestToPartnerFormSchema(),
  });

  const _HandleMemberRequestToPartnerFormOpen = (formType) => {
    memberRequestToPartnerForm.setValue('formType', formType);
    setMemberRequestToPartnerFormOpen(true);
  };

  const _HandleMemberRequestToPartnerFormClose = () => {
    memberRequestToPartnerForm.reset(memberRequestToPartnerFormDefaultValues);
    setMemberRequestToPartnerFormOpen(false);
  };

  const { mutate: downloadMemberRequestToPartnerListsExcel } =
    fitMemberToPartnerServices.useMutationDownloadMemberRequestToPartnerListsExcel(
      () => {
        setTimeout(() => {
          setLoading2(false);
        }, 600);
      }
    );

  const { watch, control } = useForm({
    defaultValues: {
      search_text: '',
      change_sponsor: null,
      member_status: null,
      request_status: null,
    },
  });

  fitMemberToPartnerServices.useQueryGetMemberRequestToPartner(
    {
      take: pageSize,
      page,
      search_text: watch('search_text'),
      change_sponsor: watch('change_sponsor'),
      member_status: watch('member_status'),
      request_status: watch('request_status'),
    },
    (data) => {
      setData(data.data);
      setTotal(data.meta.total);
    }
  );

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      width: 80,
      render: (_, record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: 'รหัสสมาชิก',
      dataIndex: 'MemberCode',
      key: 'MemberCode',
      width: 120,
      render: (_, record) => <span>{record.MemberCode}</span>,
    },
    {
      title: 'ชื่อสมาชิก',
      dataIndex: 'MemberName',
      key: 'MemberName',
      width: 200,
      render: (_, record) => <span>{record.MemberName}</span>,
    },
    {
      title: 'โทรศัพท์',
      dataIndex: 'mobile',
      key: 'mobile',
      width: 140,
      render: (_, record) => <span>{record.Mobile}</span>,
    },
    {
      title: 'อีเมล',
      dataIndex: 'email',
      key: 'email',
      width: 200,
      render: (_, record) => <span>{record.Email}</span>,
    },
    {
      title: 'Line ID',
      dataIndex: 'lineId',
      key: 'lineId',
      width: 200,
      render: (_, record) => <span>{record.LineId}</span>,
    },
    {
      title: 'ผู้แนะนำ',
      dataIndex: 'Sponsor',
      key: 'Sponsor',
      width: 200,
      render: (_, record) => (
        <div>
          <div>รหัส: {record.SponsorCode}</div>
          <div>ชื่อ: {record.SponsorName}</div>
        </div>
      ),
    },
    {
      title: 'วันที่สมัคร',
      dataIndex: 'RegisterDate',
      key: 'RegisterDate',
      width: 150,
      align: 'center',
      render: (_, record) => (
        <span>{dayjs(record.RegisterDate).format('DD/MMM/YYYY')}</span>
      ),
    },
    {
      title: 'วันที่ร้องขอ',
      dataIndex: 'RequestDate',
      key: 'RequestDate',
      width: 150,
      align: 'center',
      render: (_, record) => {
        return (
          <div>
            <div>{dayjs(record.RequestDate).format('DD/MMM/YYYY')}</div>
            {dayjs().diff(record.RequestDate, 'days') > 2 &&
              record.RequestStatus === 'request' && (
                <div style={{ color: 'red' }}>
                  (ขอมาแล้ว {dayjs().diff(record.RequestDate, 'days')} วัน)
                </div>
              )}
          </div>
        );
      },
    },
    {
      title: 'สถานะ',
      dataIndex: 'Status',
      key: 'Status',
      width: 150,
      render: (_, record) => (
        <span>
          {
            EMemberStatus.find((item) => {
              return item.value === record.Status;
            }).label
          }
        </span>
      ),
    },
    {
      title: 'เปลี่ยนผู้แนะนำ',
      dataIndex: 'ChangeSponsor',
      key: 'ChangeSponsor',
      width: 150,
      render: (_, record) => {
        return record.ChangeSponsor ? (
          <span style={{ color: 'red' }}>เปลี่ยนผู้แนะนำ</span>
        ) : (
          <span>ผู้แนะนำเดิม</span>
        );
      },
    },
    {
      title: 'ผู้แนะนำใหม่',
      dataIndex: 'NewSponsor',
      key: 'NewSponsor',
      width: 200,
      render: (_, record) => (
        <div>
          <div>รหัส: {record.NewSponsorCode}</div>
          <div>ชื่อ: {record.NewSponsorName}</div>
        </div>
      ),
    },
    {
      title: 'ความยินยอม',
      dataIndex: 'Consent',
      key: 'Consent',
      width: 300,
      children: [
        {
          title: 'แนะนำสินค้า',
          dataIndex: 'ProductAdvise',
          key: 'ProductAdvise',
          width: 150,
          align: 'center',
          render: (_, record) => (
            <div>
              <div>
                {record.ProductAdvise === 1 ? (
                  <FaCheckCircle style={{ color: 'green' }} />
                ) : (
                  <FaTimesCircle style={{ color: 'red' }} />
                )}
              </div>
            </div>
          ),
        },
        {
          title: 'แนะนำธุรกิจ',
          dataIndex: 'BusinessAdvise',
          key: 'BusinessAdvise',
          width: 150,
          align: 'center',
          render: (_, record) => (
            <div>
              <div>
                {record.BusinessAdvise === 1 ? (
                  <FaCheckCircle style={{ color: 'green' }} />
                ) : (
                  <FaTimesCircle style={{ color: 'red' }} />
                )}
              </div>
            </div>
          ),
        },
      ],
    },
    {
      title: 'เพิ่มเติม',
      dataIndex: 'PartnerRemark',
      key: 'PartnerRemark',
      width: 200,
      render: (_, record) => <span>{record.PartnerRemark}</span>,
    },
    {
      title: 'หมายเหตุ',
      dataIndex: 'StaffRemark',
      key: 'StaffRemark',
      width: 200,
      render: (_, record) => <span>{record.StaffRemark}</span>,
    },
    {
      title: 'การตอบกลับ',
      dataIndex: 'RequestStatus',
      key: 'RequestStatus',
      fixed: 'right',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: 20,
              backgroundColor:
                record.RequestStatus === 'request'
                  ? 'red'
                  : record.RequestStatus === 'response'
                  ? 'green'
                  : 'white',
              marginRight: 10,
            }}
          />
          <span>
            {
              EMemberRequestToPartnerStatus.find((item) => {
                return item.value === record.RequestStatus;
              }).label
            }
          </span>
        </div>
      ),
    },
    {
      title: '',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <div
          style={{ display: 'flex', justifyContent: 'center' }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={() => {
              console.log(record.id);
              memberRequestToPartnerForm.setValue('id', record.Id);
              _HandleMemberRequestToPartnerFormOpen('edit');
            }}
          >
            <FaPen />
          </div>
        </div>
      ),
    },
    {
      title: '',
      dataIndex: 'test',
      key: 'test',
      width: 200,
      render: (_, record) => <span></span>,
    },
  ];

  return (
    <Panel>
      <PanelHeader>คำร้องสมาชิกขอเป็นนักธุรกิจ</PanelHeader>
      <PanelBody>
        <div
          style={{ display: 'flex', alignItems: 'flex-end' }}
          className="mb-2"
        >
          <div>
            <Typography.Text>การตอบกลับ</Typography.Text>
            <Controller
              name="request_status"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <Select
                    value={value}
                    style={{ width: 200, marginRight: 10 }}
                    onChange={(status) => {
                      onChange(status);
                    }}
                    placeholder="สถานะ"
                  >
                    <Select.Option value={null}>ทั้งหมด</Select.Option>
                    {EMemberRequestToPartnerStatus.map((item) => {
                      return (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                );
              }}
            />
          </div>
          <Controller
            name="search_text"
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="ค้นหาด้วยชื่อ-สกุล, รหัสนักธุรกิจ"
                  className="mr-2"
                />
              );
            }}
          />
          <div>
            <Typography.Text>สถานะสมาชิก</Typography.Text>
            <Controller
              name="member_status"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <Select
                    value={value}
                    style={{ width: 200, marginRight: 10 }}
                    onChange={(status) => {
                      onChange(status);
                    }}
                    placeholder="สถานะ"
                  >
                    <Select.Option value={null}>ทั้งหมด</Select.Option>
                    {EMemberStatus.map((item) => {
                      return (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                );
              }}
            />
          </div>
          <div>
            <Typography.Text>เปลี่ยนผู้แนะนำ</Typography.Text>
            <Controller
              name="change_sponsor"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <Select
                    value={value}
                    style={{ width: 200, marginRight: 10 }}
                    onChange={(status) => {
                      onChange(status);
                    }}
                    placeholder="สถานะ"
                  >
                    <Select.Option value={null}>ทั้งหมด</Select.Option>
                    {[true, false].map((item) => {
                      return (
                        <Select.Option key={item} value={item}>
                          {item ? 'เปลี่ยนผู้แนะนำ' : 'ผู้แนะนำเดิม'}
                        </Select.Option>
                      );
                    })}
                  </Select>
                );
              }}
            />
          </div>
          <Button
            type="primary"
            onClick={() => {
              setLoading2(true);
              downloadMemberRequestToPartnerListsExcel({
                take: -1,
                page: 1,
                search_text: watch('search_text'),
                change_sponsor: watch('change_sponsor'),
                member_status: watch('member_status'),
                request_status: watch('request_status'),
              });
            }}
            loading={loading2}
          >
            <FaDownload className="mr-2" />
            โหลด excel
          </Button>
        </div>
        <Table
          columns={columns}
          dataSource={legacySurveyLists}
          style={{ backgroundColor: '#fff' }}
          rowKey="id"
          onChange={({ current }) => {
            setPage(current);
          }}
          width={900}
          scroll={{ x: 900 }}
          pagination={{
            pageSize,
            total,
          }}
        />
      </PanelBody>
      <FormProvider {...memberRequestToPartnerForm}>
        <MemberRequestToPartnerModal
          open={memberRequestToPartnerFormOpen}
          handleClose={_HandleMemberRequestToPartnerFormClose}
        />
      </FormProvider>
    </Panel>
  );
};

export default MemberRequestToPartnerPage;
